export default __webpack_public_path__ + "static/media/gallery_02.60844da4.jpg";